import {
  ServicePaidFlag,
  ServiceReserveStatus,
  ServiceViewType,
} from "@/apis/clients";
import {
  useCannotOrderReasons,
  useServiceFormUiState,
  useServiceInfo,
} from "@/states/service-form/selectors";
import { useRouter } from "next/router";
import { useMemo } from "react";

export const useSubmitForm = () => {
  const router = useRouter();
  const serviceFormUiState = useServiceFormUiState();
  const cannotOrderReasons = useCannotOrderReasons();
  const errors =
    serviceFormUiState.status === "Loaded"
      ? serviceFormUiState.errors
      : undefined;
  const errorsDraft =
    serviceFormUiState.status === "Loaded"
      ? serviceFormUiState?.draft?.errors
      : undefined;
  const service = useServiceInfo();

  const isPaymentFormFlg = (): boolean => {
    if (!service) return false;

    if (service.type === "calendar") {
      if (serviceFormUiState.status === "Loaded") {
        if (!serviceFormUiState.inputs.service) return false;
        const serviceMenu = service.menus.filter(
          (menu) => menu.id === serviceFormUiState.inputs.service.serviceMenuId,
        );
        if (serviceMenu.length > 0 && serviceMenu[0].price > 0) return true;
      }
      return false;
    }

    if (service.type === "event-seminar" || service.type === "form") {
      let playFlagResult = service.details.map((detail) => {
        return detail.price && detail.price > 0;
      });
      if (service.reserveStatus === ServiceReserveStatus.ALL) {
        playFlagResult = service.details.map((detail) => {
          return detail.price && detail.price > 0;
        });
      }

      return playFlagResult.includes(true);
    }

    if (
      service.type === "content-webinar" &&
      service.paid_flag === ServicePaidFlag.PAID
    ) {
      if (!service.details) return false;
      const playFlagResult = service.details.map((detail) => {
        return detail.price && detail.price > 0;
      });
      return playFlagResult.includes(true);
    }

    return false;
  };
  const canSubmit = useMemo(() => {
    if (cannotOrderReasons.length > 0) return false;
    if (!errors) {
      return false;
    }

    if (errors.service.detailIds && errors.service.detailIds.length > 0) {
      return false;
    }

    if (errors.service.optionIds && errors.service.optionIds.length > 0) {
      return false;
    }
    return Object.values(errors.customer).every(
      (fieldErrors) => fieldErrors.length === 0,
    );
  }, [cannotOrderReasons, errors]);

  const canSubmitOnLp = useMemo(() => {
    if (cannotOrderReasons.length > 0) return false;
    if (serviceFormUiState.status !== "Loaded") return false;

    if (serviceFormUiState.formData.service.type === "subscription") {
      if (!errors) {
        return false;
      }

      if (errors.service.detailIds && errors.service.detailIds.length > 0) {
        return false;
      }

      if (errors.service.isErrorCapacity) {
        return false;
      }
    }

    if (
      serviceFormUiState.formData.service.viewType === ServiceViewType.BUTTON
    ) {
      return true;
    }

    if (
      serviceFormUiState.formData.service.type === "calendar" ||
      serviceFormUiState.formData.service.type === "event-seminar" ||
      serviceFormUiState.formData.service.type === "form" ||
      serviceFormUiState.formData.service.type === "subscription"
    ) {
      if (!errors) {
        return false;
      }

      if (errors.service.detailIds && errors.service.detailIds.length > 0) {
        return false;
      }
      if (errors.service.optionIds && errors.service.optionIds.length > 0) {
        return false;
      }

      if (errors.service.isErrorCapacity) {
        return false;
      }
    }

    if (!errors) {
      return false;
    }
    return Object.values(errors.customer).every(
      (fieldErrors) => fieldErrors.length === 0,
    );
  }, [cannotOrderReasons.length, errors, serviceFormUiState]);

  const canSubmitDraft = useMemo(() => {
    if (!errorsDraft) {
      return false;
    }

    return Object.values(errorsDraft?.customer).every(
      (fieldErrors) => fieldErrors.length === 0,
    );
  }, [errorsDraft]);
  const canSubmitMenuDraft = useMemo(() => {
    if (!errorsDraft) {
      return false;
    }
    if (
      errorsDraft.service.detailIds &&
      errorsDraft.service.detailIds.length > 0
    ) {
      return false;
    }
    if (
      errorsDraft.service.optionIds &&
      errorsDraft.service.optionIds.length > 0
    ) {
      return false;
    }
    return Object.values(errorsDraft?.customer).every(
      (fieldErrors) => fieldErrors.length === 0,
    );
  }, [errorsDraft]);
  return {
    isPaymentFormFlg,
    canSubmit,
    errors,
    canSubmitDraft,
    canSubmitOnLp,
    canSubmitMenuDraft,
    errorsDraft,
  };
};
